

import React, { useEffect, useState } from 'react'
import { ProgressBar } from 'react-loader-spinner';
import Header from 'units/dashboard/components/Header';
import { SidebarProvider } from 'units/dashboard/context/SidebarProvider';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import AdminSidebar from 'units/admin/components/AdminSidebar';
import Footer from 'units/dashboard/components/Footer';
import { adminSetting, adminSettingEdit } from './services/settingServices'
import { PulseLoader } from 'react-spinners';
export default function Setting() {
  const [list, setList] = useState({
    tokenFee: '',       // مقدار نمایشی (مثلاً ۲.۴)
    _tokenFeeRaw: 0,    // مقدار واقعی عددی بدون فرمت (مثلاً 2.4)
    taxFee: "",
    zibal: false,
    zarinpal: false,
    ragSize: "",
    ragRate: "",
    memorySize: "",
    maxChunksPerGroup: 0
  });

  const [initialList, setInitialList] = useState(null);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const [loading, setLoading] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);

  // تبدیل اعداد فارسی و عربی به انگلیسی
  function toEnglishDigits(str) {
    if (typeof str !== 'string') return '';
    return str.replace(/[\u06F0-\u06F9]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
      .replace(/[\u0660-\u0669]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString());
  }

  // اضافه کردن کامای فارسی هر سه رقم
  // const addCommas = (num) => {
  //   const n = Number(toEnglishDigits(num || '0').replace(/[,٬]/g, ''));
  //   return new Intl.NumberFormat('fa-IR').format(n);
  // };
  const addCommas = (num) => {
    const n = parseFloat(toEnglishDigits(num || '0').replace(/[,٬]/g, ''));
    return new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 2 }).format(n);
  };


  const handleNumberChange = (e, key) => {
    let value = e.target.value;
    value = value.replace(/٫/g, '.').replace(/٬/g, '');
    value = toEnglishDigits(value);
    if (!/^\d*\.?\d*$/.test(value)) return;
    setList(prev => ({ ...prev, [key]: value }));
  };

  const handleCheckboxChange = (e, key) => {
    setList(prev => ({ ...prev, [key]: e.target.checked }));
  };

  const setting = async () => {
    setLoading(true);
    try {
      const res = await adminSetting(accessToken);
      if (res?.ok && res?.data) {
        const formattedData = {
          tokenFee: (res.data.tokenFee?.toString() || ''),
          taxFee: addCommas(res.data.taxFee?.toString() || ''),
          memorySize: addCommas(res.data.memorySize?.toString() || ''),
          ragSize: addCommas(res.data.ragSize?.toString() || ''),
          ragRate: addCommas(res.data.ragRate?.toString() || ''),
          zibal: res.data.zibal ?? false,
          zarinpal: res.data.zarinpal ?? false,
          maxChunksPerGroup: res.data.maxChunksPerGroup
        };
        setList(formattedData);
        setInitialList(formattedData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setting();
  }, []);

  // تابع کمکی برای گرفتن مقدار نهایی (اگه خالی بود، مقدار اولیه رو برداره)
  const getFinalValue = (field) => {
    const raw = list[field];
    if (raw === "" || raw == null) {
      return parseFloat(toEnglishDigits(initialList[field]).replace(/[,٬]/g, ''));
    }
    return parseFloat(toEnglishDigits(raw).replace(/[,٬]/g, ''));
  };

  const prepareData = () => ({
    tokenFee: getFinalValue("tokenFee"),
    taxFee: getFinalValue("taxFee"),
    memorySize: getFinalValue("memorySize"),
    ragSize: getFinalValue("ragSize"),
    ragRate: getFinalValue("ragRate"),
    zibal: list.zibal,
    zarinpal: list.zarinpal,
    maxChunksPerGroup: list.maxChunksPerGroup
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnDisable(true);
    try {
      const finalData = prepareData();
      const res = await adminSettingEdit({
        accessToken,
        ...finalData
      });

      if (res?.ok) {
        toast.success("تنظیمات با موفقیت ذخیره شد");
        const updatedData = {
          tokenFee: (res.data.tokenFee?.toString() || ''),
          taxFee: addCommas(res.data.taxFee?.toString() || ''),
          memorySize: addCommas(res.data.memorySize?.toString() || ''),
          ragSize: addCommas(res.data.ragSize?.toString() || ''),
          ragRate: addCommas(res.data.ragRate?.toString() || ''),
          zibal: res.data.zibal ?? false,
          zarinpal: res.data.zarinpal ?? false,
          maxChunksPerGroup: res.data.maxChunksPerGroup
        };
        setList(updatedData);
        setInitialList(updatedData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setBtnDisable(false);
    }
  };

  return (
    <>
      <SidebarProvider>
        <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
          <Header />
        </nav>

        <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
          <AdminSidebar />
        </div>
      </SidebarProvider>

      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <ProgressBar
            visible={true}
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        <div className="flex flex-col min-h-screen mt-4">
          <div className="main-content flex-grow pt-16 pb-12">
            <div className="container-fluid px-[0.625rem] mt-10">
              <div className="grid grid-cols-1 mb-2">
                <div className="flex items-center justify-between">
                  <h4 className="mb-sm-0 text-xl font-semibold grow text-gray-800 ">
                    تنظیمات
                  </h4>
                  <nav className="flex" aria-label="Breadcrumb"></nav>
                </div>
              </div>
              <h1 className="text-md mr-2">

                در این بخش شما می توانید تنظیمات را انجام دهید.
              </h1>
            </div>
            <div className="mt-10 flex items-center justify-center p-2 col-span-12 xl:col-span-9 my-10">
              <div className="w-full max-w-5xl  rtl ">
                <form onSubmit={handleSubmit}>
                  <div className="space-y-12">


                    <div className="border-b border-gray-900/10 pb-12">


                      <div className="mt-1 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="flex items-center justify-start gap-3 sm:col-span-3">
                          <label htmlFor="tokenFee" className="block text-sm/6 font-medium text-gray-900">
                            قیمت هر توکن
                          </label>
                          <div className="mt-2">
                            <input
                              id="tokenFee"
                              name="tokenFee"
                              value={list.tokenFee}
                              onChange={(e) => handleNumberChange(e, 'tokenFee')}
                              type="text"
                              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-none focus:border-[#aadec5] focus:ring-2 focus:ring-[#aadec5]  sm:text-sm/6"
                            />
                          </div>
                          ریال
                        </div>

                        <div className="flex items-center justify-start gap-3 sm:col-span-3">
                          <label htmlFor="taxFee" className="block ml-3 text-sm/6 font-medium text-gray-900">
                            درصد مالیات
                          </label>
                          <div className="mt-2">
                            <input
                              id="taxFee"
                              name="taxFee"
                              value={list?.taxFee}
                              onChange={(e) => handleNumberChange(e, 'taxFee')}
                              type="text"

                              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-none focus:border-[#aadec5] focus:ring-2 focus:ring-[#aadec5] sm:text-sm/6"
                            />
                          </div>

                        </div>

                      </div>
                    </div>

                    <div className="border-b border-gray-900/10 pb-12">
                      <h2 className="text-base/7 font-semibold text-gray-900">درگاه پرداخت</h2>
                      <p className="mt-1 text-sm/6 text-gray-600">
                        لطفاً درگاه‌هایی را که مایل به فعال‌سازی آن‌ها برای پرداخت هستید، انتخاب نمایید.
                      </p>

                      <div className="mt-1 space-y-1">
                        <fieldset>
                          <legend className="text-sm/6 font-semibold text-gray-900"></legend>
                          <div className="mt-1 space-y-1">
                            <div className="flex items-center gap-3">
                              <div className="flex h-6 shrink-0 items-center">
                                <div className="group grid size-4 grid-cols-1">
                                  <input

                                    id="zarinpal"
                                    name="zarinpal"
                                    checked={list?.zarinpal}
                                    onChange={(e) => handleCheckboxChange(e, 'zarinpal')}
                                    type="checkbox"
                                    aria-describedby="comments-description"
                                    className=" rounded-sm "
                                  />
                                  <svg
                                    fill="none"
                                    viewBox="0 0 14 14"
                                    className="pointer-events-none size-3.5 self-center justify-self-center stroke-white"
                                  >
                                    <path
                                      d="M3 8L6 11L11 3.5"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="opacity-0 group-has-checked:opacity-100"
                                    />
                                    <path
                                      d="M3 7H11"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="opacity-0 group-has-indeterminate:opacity-100"
                                    />
                                  </svg>
                                </div>
                              </div>
                              <div className="flex items-center text-sm/6  px-5 my-auto">
                                <label htmlFor="zarinpalIPG" className="font-medium text-gray-900">
                                  درگاه پرداخت
                                </label>
                                <div id="comments-description" className="text-gray-500 w-[80px] h-[40px]">
                                  <img src="/Zarrinpal-Logo.png" alt="Zarrinpal Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center gap-3">
                              <div className="flex h-6 shrink-0 items-center">
                                <div className=" group grid size-4 grid-cols-1">
                                  <input
                                    id="zibal"
                                    name="zibal"
                                    checked={list?.zibal}
                                    onChange={(e) => handleCheckboxChange(e, 'zibal')}
                                    type="checkbox"
                                    aria-describedby="candidates-description"

                                    className=" col-start-1 row-start-1  rounded-sm  "
                                  />
                                  <svg
                                    fill="none"
                                    viewBox="0 0 14 14"
                                    className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25  peer-checked:opacity-100 opacity-0"
                                  >
                                    <path
                                      d="M3 8L6 11L11 3.5"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="stroke-white peer-checked:stroke-[#42b883]"
                                    />
                                    <path
                                      d="M3 7H11"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="opacity-0 group-has-indeterminate:opacity-100"
                                    />
                                  </svg>
                                </div>
                              </div>
                              <div className="text-sm/6  px-3 my-auto flex items-center">
                                <label htmlFor="zibalIPG" className="font-medium text-gray-900">
                                  درگاه پرداخت
                                </label>
                                <div id="candidates-description-description" className="text-gray-500 w-[80px] h-[40px]">
                                  <img src="/zibal.png" alt="zibal Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                </div>
                              </div>
                            </div>

                          </div>
                        </fieldset>
                      </div>
                    </div>

                    <div className="border-b border-gray-900/10 pb-12">


                      <div className="mt-1 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <h2 className="text-base/7 font-semibold text-gray-900">تنظیمات rag</h2>
                        <div className="flex items-center justify-start gap-3 sm:col-span-3">
                          <label htmlFor="memorySize" className="block ml-14 text-sm/6 font-medium text-gray-900">
                            تعداد پیام حافظه
                          </label>
                          <div className="mt-2">
                            <input
                              id="memorySize"
                              name="memorySize"
                              value={(list?.memorySize)}
                              onChange={(e) => handleNumberChange(e, 'memorySize')}
                              type="text"
                              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-none focus:border-[#aadec5] focus:ring-2 focus:ring-[#aadec5]  sm:text-sm/6"
                            />
                          </div>
                        </div>

                        <div className="flex items-center justify-start gap-3 sm:col-span-3">
                          <label htmlFor="ragSize" className="block ml-11 text-sm/6 font-medium text-gray-900">
                            تعداد رکوردهای rag
                          </label>
                          <div className="mt-2">
                            <input
                              id="ragSize"
                              name="ragSize"
                              value={(list?.ragSize)}
                              onChange={(e) => handleNumberChange(e, 'ragSize')}
                              type="text"

                              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-none focus:border-[#aadec5] focus:ring-2 focus:ring-[#aadec5] sm:text-sm/6"
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-start gap-3 sm:col-span-3">
                          <label htmlFor="ragRate" className="block  text-sm/6 font-medium text-gray-900 ml-10">
                            درصد میزان شباهت
                          </label>
                          <div className="mt-2">
                            <input
                              id="ragRate"
                              name="ragRate"
                              value={list?.ragRate}
                              onChange={(e) => handleNumberChange(e, 'ragRate')}
                              type="text"

                              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-none focus:border-[#aadec5] focus:ring-2 focus:ring-[#aadec5] sm:text-sm/6"
                            />
                          </div>
                        </div>
                        <div className="flex items-center justify-start gap-3 sm:col-span-3">
                          <label htmlFor="ragRate" className="block  text-sm/6 font-medium text-gray-900 ml-10">
                            تعداد چانک ها برای چانک های گروهی
                          </label>
                          <div className="mt-2">
                            <input
                              id="maxChunksPerGroup"
                              name="maxChunksPerGroup"
                              value={list?.maxChunksPerGroup}
                              onChange={(e) => handleNumberChange(e, 'maxChunksPerGroup')}
                              type="text"

                              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-none focus:border-[#aadec5] focus:ring-2 focus:ring-[#aadec5] sm:text-sm/6"
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div className="mt-6 flex items-center justify-end gap-x-6">

                    <button
                      type="submit"
                      className="w-full rounded-md bg-[#aadec5] px-3 py-2 text-sm font-semibold text-gray-800 shadow-xs hover:bg-[#7fe1b2] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#7fe1b2]"
                      disabled={btnDisable}
                    >
                      {!btnDisable ? "ثبت" : <PulseLoader
                        color="#f2f1f1"
                        size={9}
                      />}

                    </button>
                  </div>
                </form>


              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  )
}
